const getMapFromStringArray = (stringArray?: string[]) => {
    const result: Record<string, boolean> = {};

    stringArray?.forEach(value => result[value] = true);

    return result;
}

export default getMapFromStringArray;
